<div [class]="'snackbar-container ' + typeClass">
  <div class="snackbar-content">
    <mat-icon class="snackbar-icon">{{ iconName }}</mat-icon>
    <span class="snackbar-message">{{ data.message }}</span>
  </div>
  <button mat-icon-button aria-label="Close notification" class="snackbar-close" (click)="dismiss()">
    <mat-icon>close</mat-icon>
  </button>
</div>
